var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChatCheck = function SvgChatCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.875 20.75a.946.946 0 0 1-.67-.288l-1.917-1.916a.926.926 0 0 1 0-1.342c.383-.383 1.006-.383 1.341 0l1.246 1.246 3.162-3.162a.926.926 0 0 1 1.342 0 .926.926 0 0 1 0 1.341l-3.833 3.833a.946.946 0 0 1-.671.288z",
    fill: "#335EEA",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.865V6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v9.01l.025-.01v4.586a1 1 0 0 1-1.707.707L18.025 18h-5.041A7.5 7.5 0 0 0 2 11.865zM6 7a1 1 0 1 0 0 2h9a1 1 0 0 0 0-2H6z",
    fill: "#335EEA"
  }))));
};

export { SvgChatCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48cGF0aCBkPSJNNC44NzUgMjAuNzVhLjk0Ni45NDYgMCAwMS0uNjctLjI4OGwtMS45MTctMS45MTZhLjkyNi45MjYgMCAwMTAtMS4zNDJjLjM4My0uMzgzIDEuMDA2LS4zODMgMS4zNDEgMGwxLjI0NiAxLjI0NiAzLjE2Mi0zLjE2MmEuOTI2LjkyNiAwIDAxMS4zNDIgMCAuOTI2LjkyNiAwIDAxMCAxLjM0MWwtMy44MzMgMy44MzNhLjk0Ni45NDYgMCAwMS0uNjcxLjI4OHoiIGZpbGw9IiMzMzVFRUEiIG9wYWNpdHk9Ii4zIi8+PHBhdGggZD0iTTIgMTEuODY1VjZhMyAzIDAgMDEzLTNoMTRhMyAzIDAgMDEzIDN2OS4wMWwuMDI1LS4wMXY0LjU4NmExIDEgMCAwMS0xLjcwNy43MDdMMTguMDI1IDE4aC01LjA0MUE3LjUgNy41IDAgMDAyIDExLjg2NXpNNiA3YTEgMSAwIDEwMCAyaDlhMSAxIDAgMDAwLTJINnoiIGZpbGw9IiMzMzVFRUEiLz48L2c+PC9zdmc+";